import React from 'react';

const AJAX_Intro = () => {
  return (
    <div >
      <h1>AJAX_Intro</h1>
      <p>Placeholder component for: "AJAX Intro"</p>
    </div>
  );
};

export default AJAX_Intro;
